import { DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Inject,
} from '@angular/core';
import { environment } from '../../../environments';
import { I2gNgTrackingService } from 'i2g-ng-tracking';
import { combineLatest } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { LocalizationStore } from '../../../localization/store/stores';
import {
  AppDispatcher,
  BrowserManagerStore,
  IBrowserInfoHeaders,
} from '../../store';
import { IPreventWindowUnloadingOptions } from 'i2g-ng-ui';
import {
  CookieService,
  DateTimeService,
  HttpService,
  KenshooService,
} from 'i2g-ng-utils';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements AfterViewInit {
  preventWindowUnloadingOptions: IPreventWindowUnloadingOptions;

  constructor(
    private _httpService: HttpService,
    private _appDispatcher: AppDispatcher,
    @Inject(DOCUMENT) private _document: Document,
    private _trackingService: I2gNgTrackingService,
    private _localizationStore: LocalizationStore,
    private _browserManagerStore: BrowserManagerStore,
    private _dateTimeService: DateTimeService,
    private _cookieService: CookieService,
    private _kenshooService: KenshooService
  ) {
    console.log(`Account Web ${environment.version}`);

    this.preventWindowUnloadingOptions = {
      onBeforeUnload: this._httpService.anyOutboundRequests.bind(
        this._httpService
      ),
    };

    this._cookieService.init(environment.domain);

    this._appDispatcher.initErrorHandler(environment);

    this._trackingService.load(environment.segmentWriteKey, {
      app_name: 'account_web',
      app_version: environment.version,
    });

    combineLatest([
      this._browserManagerStore.getBrowserInfoHeaders(),
      this._localizationStore.getCurrentLocale(),
    ])
      .pipe(
        filter(
          ([browserInfoHeaders, locale]: [IBrowserInfoHeaders, string]) =>
            !!(browserInfoHeaders && locale)
        ),
        take(1),
        map(([browserInfoHeaders, locale]: [IBrowserInfoHeaders, string]) => ({
          ...browserInfoHeaders,
          'x-i2g-locale': locale,
          'x-i2g-timezone': this._dateTimeService.getTimezone(),
        }))
      )
      .subscribe((httpHeaders: any) => {
        this._httpService.setBaseHeaders(httpHeaders);
      });

    this._kenshooService.loadInfinityTagScript();
  }

  ngAfterViewInit() {
    this._document.body.classList.add('loaded');
  }
}
